export default __webpack_public_path__ + "static/media/airtiketa-logo.89ed4753.png";